import React from 'react';
import ReactDOM from 'react-dom';
import ListPage from './app/app';
import { Provider } from 'react-redux';
import store from './data/store';
import { initBlackFridayFreePluginPopup } from '../black-friday/free-plugin-popup';

/**
 * entry point
 */
const init = () => {
    const $root = document.getElementById('list-page-react-app');
    if (!$root) return;

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={ store }>
                <ListPage />
            </Provider>
        </React.StrictMode>,
        $root
    );

    initBlackFridayFreePluginPopup();
};

init();